export const directions = {
    HORIZONTAL:1,
    VERTICAL:2
};

export const defaultDimensions = {
    HORIZONTAL: 8,
    VERTICAL:8
}